











































































import { defineComponent, toRefs } from '@vue/composition-api';

import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppInput from '@berlin-front/common/components/elements/AppInput';
import AppPassword from '@berlin-front/common/components/elements/AppPassword';
import AppProgressBar from '@berlin-front/common/components/elements/AppProgressBar';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import AtoneAlert from '@berlin-front/common/components/atone-components/AtoneAlert';

import FlashMessage from '@berlin-front/common/components/clusters/FlashMessage';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';

import { useContext } from '@berlin-front/common/composables/context';
import { ALERT_TYPE } from '@berlin-front/common/components/atone-components/AtoneAlert/composable';
import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { ModalBridgeContext } from '@services/ModalBridgeContext';
import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { LINE_HEIGHT, TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';

import { HEIGHT_TYPE } from '@berlin-front/common/components/elements/AppProgressBar/composable';

import { ROUTE_NAME } from '@/router/route-name';
import { LiteLoginAtoneContext } from './composable';

export default defineComponent({
  name: 'AtoneLiteLoginView',
  components: {
    AppButton,
    AppCard,
    AppContainer,
    AppInput,
    AppPassword,
    AppProgressBar,
    AppRow,
    AppText,
    FlashMessage,
    ModalHeader,
    AtoneAlert,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  setup() {
    const { useLiteLoginAtone } = useContext(LiteLoginAtoneContext);
    const bridge = useContext(ModalBridgeContext);

    const {
      // 状態
      state,

      // 期限日
      dueDate,

      // 表示項目
      messages,

      // progress
      progress,
      progressIsLoading,

      // action
      onSubmit,
      openMyPageRemind,
      normalize,

      // validator
      v$,
      getError,
    } = toRefs(useLiteLoginAtone());

    const showHelp = () => {
      if (progressIsLoading.value) return;
      bridge.showHelp();
    };

    return {
      ALERT_TYPE,
      // 状態
      state,

      // 期限日
      dueDate,

      // 表示項目
      messages,

      // // 関数
      onSubmit,
      openMyPageRemind,
      showHelp,
      normalize,

      // // 定数値
      HEIGHT_TYPE,
      TEXT_SIZE,
      TEXT_WEIGHT,
      ROUTE_NAME,
      LINE_HEIGHT,
      HEADER_TYPE,

      // // progress
      progress,
      progressIsLoading,

      // // validator
      v$,
      getError,
    };
  },
});
